import CONST_REQUEST from '../../constants/request';
import * as api from '../../api/approval';
import apiTools from '../../utils/store'

const types = {
    ...apiTools.getTypes([
        'orderDetail',
        'listUserWithNum',
    ]),
}

const getDefaultState = () => {
    return {
        ...apiTools.getStates([
            'orderDetail',
            'listUserWithNum',
        ]),
    }
}

const getters = {
        ...apiTools.getGetters([
            'orderDetail',
            'listUserWithNum',
        ])
    }

const buildAction = (apiName) => {
    return ({ commit }, params) => {
        return api[apiName](params).then((res) => {
            if (res.code == CONST_REQUEST.CODE_SUCCESS) {
                return res
            } else {
                throw new Error(res.msg)
            }
        })
    }
}

const actions = {
        ...apiTools.getActions([
            // 'getOrderDetail',
            'getListUserWithNum',
        ], { types, api, CONST_REQUEST }),
        auditApproval: buildAction('auditApproval'),
        getApprovalListItem: buildAction('getApprovalListItem'),
        batchChangeUser: buildAction('batchChangeUser'),
    }

const mutations = {
    ...apiTools.getMutations([
        'orderDetail',
        'listUserWithNum',
    ], { types, CONST_REQUEST })
}


export default {
    namespaced: true,
    state: getDefaultState(),
    getters,
    actions,
    mutations
}